import { Stepper } from '@ordr-as/umami-react/stepper';
import { useUpdateCartItems } from './useUpdateCartItems';
import { OrderLineDto } from '../../../../../../generated-api';
import React from 'react';

type QuantityButtonsProps = { orderLine: OrderLineDto };

const QuantityButtons = (props: QuantityButtonsProps) => {
  const { orderLine } = props;
  const updateCartItems = useUpdateCartItems();

  return (
    <Stepper
      showQuantity={false}
      quantity={orderLine.quantity}
      onIncrease={() => updateCartItems(1, orderLine)}
      onDecrease={() => updateCartItems(-1, orderLine)}
    />
  );
};

export default React.memo(QuantityButtons);
